import styled from "styled-components";

import { CSS_VARIABLES } from "enums/cssVariables";

import { VoterCardStyleProps } from "../types";
import {
    VOTEBOX_BORDER_WIDTH,
    VOTEBOX_BOX_BORDER_COLOR,
    VOTEBOX_CARD_RADIUS,
    VOTEBOX_FONT_SIZE_BODY,
    VOTEBOX_FONT_SIZE_CAPTION,
    VOTEBOX_FONT_WEIGHT_BOLD,
    VOTEBOX_MUTED_BACKGROUND_COLOR,
    VOTEBOX_NEUTRAL_BORDER_COLOR,
    VOTEBOX_ROW_GAP,
    VOTEBOX_SECONDARY_TEXT_COLOR,
    VOTEBOX_SUCCESS_BACKGROUND_COLOR,
    VOTEBOX_SUCCESS_COLOR,
    VOTEBOX_TEXT_COLOR,
    VOTEBOX_VOTER_CARD_MIN_HEIGHT,
    VOTEBOX_WHITE,
} from "../voteboxTokens";

export const CardButton = styled.button<VoterCardStyleProps>`
    display: flex;
    align-items: center;
    gap: ${VOTEBOX_ROW_GAP};
    box-sizing: border-box;
    width: 100%;
    min-height: ${VOTEBOX_VOTER_CARD_MIN_HEIGHT};
    margin-bottom: 0.75rem;
    padding: 10px 14px;
    border: ${VOTEBOX_BORDER_WIDTH} solid
        ${(props) =>
            props.$hasVoted
                ? VOTEBOX_SUCCESS_COLOR
                : VOTEBOX_NEUTRAL_BORDER_COLOR};
    border-radius: ${VOTEBOX_CARD_RADIUS};
    /* Transparent over a background image (set by Layout), as the vote options. */
    background: ${(props) =>
        props.$hasVoted
            ? VOTEBOX_SUCCESS_BACKGROUND_COLOR
            : `var(${CSS_VARIABLES.UNSELECTED_OPTION_BACKGROUND_COLOR}, ${VOTEBOX_WHITE})`};
    color: ${VOTEBOX_TEXT_COLOR};
    font: inherit;
    text-align: start;
    cursor: pointer;
    &[disabled] {
        background: ${VOTEBOX_MUTED_BACKGROUND_COLOR};
        cursor: not-allowed;
    }
`;

export const Identity = styled.span`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    word-break: break-word;
`;

export const Name = styled.span`
    font-size: ${VOTEBOX_FONT_SIZE_BODY};
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
`;

export const Detail = styled.span`
    font-size: ${VOTEBOX_FONT_SIZE_CAPTION};
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
`;

export const StatusBadge = styled.span<VoterCardStyleProps>`
    display: flex;
    flex: none;
    align-items: center;
    gap: 5px;
    padding: 5px 11px;
    border: 1.5px
        ${(props) =>
            props.$hasVoted
                ? `solid ${VOTEBOX_SUCCESS_COLOR}`
                : `dashed ${VOTEBOX_BOX_BORDER_COLOR}`};
    border-radius: 999px;
    background: ${(props) =>
        props.$hasVoted ? VOTEBOX_SUCCESS_COLOR : "transparent"};
    color: ${(props) =>
        props.$hasVoted ? VOTEBOX_WHITE : VOTEBOX_SECONDARY_TEXT_COLOR};
    font-size: ${VOTEBOX_FONT_SIZE_CAPTION};
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
`;
